<body class="dashboard dashboard-bg superadmin-dashboard">
    <app-header></app-header>

    <div class="body-container collapsed">
        <app-sidebar></app-sidebar>

        <div class="body-content">
            <div class="row">
                <div class="col-md-8 p-0">
                    <app-page-header title="{{'Device Versions' | translate}}" iconClass="fas fa-laptop-code"></app-page-header>
                </div>

                <div class="col-md-4 p-0">
                    <div class="text-right grid-button-container">
                        <button type="button" class="btn button-primary" mat-button (click)="add()">
                            {{'Add Version' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <app-progress-spinner [show]="isLoading || (dataSource.isLoading$ | async)"></app-progress-spinner>

            <div class="white-box">
                <mat-form-field>
                    <mat-label>{{'Search' | translate}}</mat-label>
                    <input matInput #searchField />
                    <mat-icon matPrefix class="mr-3">
                        <i class="fas fa-search"></i>
                    </mat-icon>
                </mat-form-field>

                <table mat-table [dataSource]="dataSource" matSort matSortActive="version" matSortDirection="asc"
                    matSortDisableClear>
                    <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Version' | translate}}</th>
                        <td mat-cell *matCellDef="let deviceVersion">{{deviceVersion.version}}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th class="action-column" mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
                        <td class="action-column" mat-cell *matCellDef="let deviceVersion">
                            <mat-icon class="action-icon" title="{{'Edit' | translate}}" (click)="edit(deviceVersion)">
                                <i class="fas fa-edit"></i>
                            </mat-icon>

                            <mat-icon class="action-icon color-accent" title="{{'Delete' | translate}}" (click)="delete(deviceVersion)">
                                <i class="fas fa-trash"></i>
                            </mat-icon>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                        [class.even-row]="even"></tr>
                </table>

                <mat-paginator [length]="dataSource.count$ | async" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"
                    showFirstLastButtons></mat-paginator>
            </div>

            <div class="row">
                <div class="col-lg-3 offset-lg-9">
                    <mat-form-field>
                        <mat-label>{{'Time Zone' | translate}}</mat-label>
                        <input matInput [(ngModel)]="timeZoneLabel" readonly />
                        <mat-icon matPrefix class="mr-3">
                            <i class="fas fa-globe"></i>
                        </mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <div class="clearfix"></div>
            <app-footer></app-footer>
        </div>

        <div class="clearfix"></div>
    </div>
</body>
